import { IItemVersion } from "lib/types/items";

import { VersionObject } from "../components/SelectChildSku";

/**
 * Handles team access order requests for parent-child products
 * Converts the selected team back to IItemVersion format and executes callbacks
 * to update component state and trigger the standard order flow
 *
 * @param selectedTeam - The team/version object selected by the user from the team access modal
 * @param versions - Array of available versions to find the matching team version
 * @param setSelectedVersion - Callback to update the selected version state
 * @param updateVersionSelected - Callback to notify parent component of version change
 * @returns The found team version or undefined if not found
 */
export const handleOrderTeam = (
  selectedTeam: VersionObject,
  versions: IItemVersion[],
  setSelectedVersion: (version: IItemVersion) => void,
  updateVersionSelected: (version: IItemVersion) => void
): IItemVersion | undefined => {
  // Convert VersionObject back to IItemVersion for ordering
  const teamVersion = versions.find((v) => v.taxonomyId === selectedTeam.taxonomyId);

  if (teamVersion) {
    setSelectedVersion(teamVersion);
    updateVersionSelected(teamVersion);
    return teamVersion;
  }

  return undefined;
};
